import ActivitySection from './activitySection.view';

export default ActivitySection;
